import {
  capitalize,
  startsWith
} from 'lodash'

export const getcleanlink = (link) => { 

  const siteurl = window.playmotiv.siteurl
  link = link
    .split(siteurl)
    .join('')
    .split('//')
    .join('')

  return link
}

export const getcontentparam = (pathname) => { 

  let contentindex = pathname.indexOf('content')
  contentindex = contentindex == -1 ? 1 : contentindex

  pathname = pathname.substring(contentindex)
    .split('/')
    .join('*')
    
  return pathname
}

export const getrouteclass = route => {

  if(!route) { return '' }

  const routeclass = getcleanlink(route)
  .split('/').join(' ')
  .split('-').join(' ')
  .split(' ')
  .map(w => capitalize(w))
  .join('')

  return routeclass
}

export const getroutepathclass = route => {

  if(!route) { return '' }

  const routeclasses = getcleanlink(route)
  .split('/').join(' ')
  .split('-').join(' ')
  .split(' ')
  .filter(w => !Number.isInteger(parseInt(w)))
  .join(' ')

  return routeclasses
}

export const compareroute = (pathname, link) => {
    
  return pathname.includes(getcleanlink(link))
}

export const getnavigatepath = (type, path) => { 

  let link

  switch(type) {

    case 'route':

      link = path

      break

    case 'content':

      const pathlastchar = path.charAt(path.length-1)
      if(pathlastchar == '/') {

        path = path.substring(0, path.length-1)
      } 

      link = 'content/' + path.replace(window.playmotiv.siteurl, '')
      .substring(1)
      .split('/').join('*')

      break 

    case 'logout':

      link = '/wp-login.php?action=logout'      

      break 
  }

  return link
}

export const getRouteAsClass = route => {

  let routeasclass = route
  .replace('http://', '')
  .replace('https://', '')
  routeasclass = startsWith(routeasclass, '/') ? routeasclass.substring(1) : routeasclass
  routeasclass = routeasclass.split('/').join('-')

  return routeasclass
}

export const slugify = string => {
  
  string = string.replace(/^\s+|\s+$/g, '');
  string = string.toLowerCase();
  var from = "àáãäâèéëêìíïîòóöôùúüûñç·/_,:;";
  var to   = "aaaaaeeeeiiiioooouuuunc------";

  for (var i=0, l=from.length ; i<l ; i++) {

    string = string.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i));
  }

  string = string
  .replace(/[^a-z0-9 -]/g, '') // remove invalid chars
  .replace(/\s+/g, '-') // collapse whitespace and replace by -
  .replace(/-+/g, '-'); // collapse dashes

  return string;
}
